import React, { createContext, useReducer, useEffect, Fragment } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import NavBar from '../../components/navbar/NavBar';
import Home from '../../components/home/Homepage';
import Cartographie from '../../components/map/MapPage';
import Projets from '../../components/projects/dashboard/ProjectsDashboard';
import About from '../../components/about/About';
import SignUp from '../../components/users/SignUp';
import UsersPage from '../../components/users/UsersPage';
import AccountPage from '../../components/users/AccountPage';
import SignIn from '../../components/users/SignIn';
import Erreur from '../../components/Erreur';
import { Container } from 'semantic-ui-react';
import ProjectsNew from '../../components/projects/form/ProjectsNew';
import ProjectsModif from '../../components/projects/form/ProjectsUpdate';
import ScrollToTop from '../common/utils/ScrollToTop';
import { Cgu } from '../../components/cgu/Cgu';
import ProjectDetailPage from '../../components/projects/detail/ProjectDetailPage';
import ContactPage from '../../components/contact/ContactPage';
import ContactListPage from '../../components/contact/ContactListPage';
import AuditPage from '../../components/audit/AuditPage';

export const UserContext = createContext();

const initialState = {
  loggedIn: false,
  user: null,
  token: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('token', action.payload.token);
      return { ...state, loggedIn: true, user: action.payload.user, token: action.payload.token };
    case 'LOGOUT':
      localStorage.clear();
      return { ...state, loggedIn: false, user: null, token: null };
    default:
      return state;
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || null);
    const token = localStorage.getItem('token');
    if (user && token) {
      dispatch({ type: 'LOGIN', payload: { user, token } });
    }
  }, []);

  const role = state.user?.type_utilisateur;

  // Route protégée par connexion + rôles optionnels
  const ProtectedRoute = ({ component: Component, roles, ...rest }) => (
    <Route
      {...rest}
      render={(props) => {
        if (!state.loggedIn) return <Redirect to='/connexion' />;
        if (roles && !roles.includes(role)) return <Redirect to='/cases' />;
        return <Component {...props} />;
      }}
    />
  );

  return (
    <UserContext.Provider value={{ state, dispatch }}>
      <BrowserRouter>
        <ScrollToTop />
        <Route exact path='/' component={Home} />
        <Route
          path='/(.+)'
          render={() => (
            <Fragment>
              <NavBar />
              <Container className='main'>
                <Switch>
                  <ProtectedRoute path='/map' exact component={Cartographie} />
                  <ProtectedRoute path='/cases' exact component={Projets} />
                  <ProtectedRoute
                    path='/case/new'
                    exact
                    component={ProjectsNew}
                    roles={['superadmin', 'ksi']}
                  />
                  <ProtectedRoute path='/cases/:id' exact component={ProjectDetailPage} />
                  <ProtectedRoute
                    path='/case/update/:id'
                    exact
                    component={ProjectsModif}
                    roles={['superadmin', 'ksi', 'knra']}
                  />

                  <ProtectedRoute
                    path='/inscription'
                    exact
                    component={SignUp}
                    roles={['superadmin']}
                  />
                  <ProtectedRoute
                    path='/users'
                    exact
                    component={UsersPage}
                    roles={['superadmin']}
                  />
                  <ProtectedRoute path='/account' exact component={AccountPage} />
                  <ProtectedRoute
                    path='/contacts'
                    exact
                    component={ContactListPage}
                    roles={['superadmin']}
                  />
                  <ProtectedRoute
                    path='/audit'
                    exact
                    component={AuditPage}
                    roles={['superadmin']}
                  />
                  <Route path='/contact' component={ContactPage} />
                  <Route path='/about' component={About} />
                  <Route path='/cgu' component={Cgu} />
                  <Route path='/connexion' component={SignIn} />
                  <Route component={Erreur} />
                </Switch>
              </Container>
            </Fragment>
          )}
        />
      </BrowserRouter>
    </UserContext.Provider>
  );
}

export default App;
